import { IonBackButton, IonButtons, IonCol, IonContent, IonGrid, IonHeader, IonImg, IonPage, IonRow, IonTitle, IonToolbar, useIonViewDidEnter, useIonViewWillEnter } from '@ionic/react';
import { useAppContext } from '../AppProvider';
import { useState } from 'react';

const TCUPolicy: React.FC = () => {
    const [pageContent, setPageContent] = useState<any>(null);

    const { SWOwlLogo, SWFullHorizLogo, textLogoLoaded, fadeInTextLogo, showToast } = useAppContext();

    useIonViewWillEnter(() => {
        document.body.classList.remove('dark');
    });

    useIonViewDidEnter(() => {
        const initGetContent = async () => {
            let content:object = await getContent('20');
            setPageContent(content);
        }
        initGetContent();
    });

  
    //
    // Get content from the API
    //
    const getContent = async (id: string) => {
        try {
            const response = await fetch('https://api.besolowise.com/content/get/?cid=' + encodeURIComponent(id), {
                method: 'GET',
                credentials: 'include'
            });
            if(response.ok) {
                const obj = await response.json();
                if(obj.contentID !== null) {
                    return obj; 
                } else {
                    showToast({
                        message: 'Data Error: ' + obj.message,
                        duration: 3000,
                        color: 'dark',
                        position: 'middle'
                    });
                }
            } else {
                showToast({
                    message: 'Response Error. Try again.',
                    duration: 3000,
                    color: 'dark',
                    position: 'middle'
                });
            }
        } catch(error) {
            showToast({
                message: 'Connection Error: ' + error + '. Try again.',
                duration: 3000,
                color: 'dark',
                position: 'middle'
            });
        }     
    };
  
    return (
        <IonPage>
        <IonHeader>
            <IonToolbar>
                <IonButtons slot='start'>
                    <IonBackButton color={'tertiary'}>Back</IonBackButton>
                </IonButtons>
                <IonTitle><IonImg className={textLogoLoaded ? 'fade-in' : 'fade-out'} src={SWFullHorizLogo} onIonImgDidLoad={fadeInTextLogo}></IonImg></IonTitle>
            </IonToolbar>
        </IonHeader>
        <IonContent className="ion-padding">
            <div>
                <h1 className='ion-text-center'>Terms and Conditions of Use Policy</h1>
            </div>
            <IonGrid fixed>
                <IonRow class='ion-justify-content-center'>
                    <IonCol size='12' sizeMd='8' sizeLg='8' sizeXl='8'>
                        <div dangerouslySetInnerHTML={{ __html: pageContent !== null ? pageContent?.contentContent : '' }} />
                    </IonCol>
                </IonRow>
            </IonGrid>
        </IonContent>
        </IonPage>
    );
};

export default TCUPolicy;
